/**
 * The corpus checks the backend runs today (CZNA-1217), in display order. A finite list on
 * purpose: each code has a label and a hint in the translations, and a code the backend
 * adds later still shows — as its bare code — until it gets them.
 */
export var CORPUS_CHECK_CODES = [
    'K01', 'K02', 'K03', 'K04', 'K05', 'K06', 'K07', 'K08', 'K09',
    'MONTHLY_DUP_HEADING', 'MONTHLY_DANGLING_SEE_ALSO',
    'Q1', 'Q2', 'Q3', 'Q4', 'Q5',
    'Q6_374A', 'Q6_372A', 'Q6_370C', 'Q6_368A', 'Q6_368C',
    'S1',
];
export var isCorpusCheckCode = function (code) {
    return CORPUS_CHECK_CODES.includes(code);
};
/** Ordered list of all panels for stable rendering. */
export var ISSUE_CATEGORIES = [
    'STRUCTURAL',
    'VOCABULARY',
    'MARC_LOGIC',
];
